import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import ProductListing from './pages/ProductListing';
import ProductDetail from './pages/ProductDetail';
import Login from './pages/Login';
import Register from './pages/Register';
import Header from './components/Header'; // Import the global Header component
import ResetPassword from './pages/ResetPassword';
import './styles/App.css';
import { AuthProvider } from './contexts/AuthContext';
import CategoryListing from './pages/CategoryListing';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import SearchResult from './pages/SearchResult';
import Footer from './components/Footer';
import ProfileInfo from './pages/ProfileInfo';
import ChangePassword from './pages/ChangePassword';
import OrderInfo from './pages/OrderInfo';
import ProfileGallery from './pages/ProfileGallery';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App main-with-fixed-header">
          {/* Global Header */}
          <Header />
          {/* Page Routes */}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/gallery/:profileId" element={<ProfileGallery />} />
            <Route path="/products" element={<ProductListing />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/profile" element={<ProfileInfo />} />
            <Route path="/orders" element={<OrderInfo />} />
            <Route path="/category/:categoryId" element={<CategoryListing />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/search" element={<SearchResult />} />
            <Route path="/change-password" element={<ChangePassword />} />
          </Routes>

          {/* Global Footer */}
          <Footer />
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;